import Vue from 'vue'
var vm = new Vue();

export default {
    /*广告删除*/
    delAdv({commit},params){
        return new Promise((res) => {
            Vue.http.post(vm.adserver+"/advertise/removeAdvertise",params).then(response =>{
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },

    /*发布删除*/
    delPush({commit},id){
        return new Promise((res) => {
            Vue.http.post(vm.adserver+"/advertise/endPush",{id:id,Token: localStorage.getItem('Token')}).then(response =>{
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },

    //新增/修改/用户
    editUser({commit}, params) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/user/saveUser", params).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
                this.$message({showClose: true, message: '网络异常', type: 'error'});
            })
        })
    },

    //新增/修改/用户
    findTagModule({commit}, params) {
        return new Promise((res) => {
            Vue.http.get(vm.requetHost + "/base/tag/findTagModule", params).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
                this.$message({showClose: true, message: '网络异常', type: 'error'});
            })
        })
    },
    //删除用户
    // delUser({commit},id){
    //     return new Promise((res) => {
    //         Vue.http.post(vm.requetHost + "/sys/user/delUser", {id: id}).then(response => {
    //             res(response.body)
    //         }).catch(err => {
    //             onsole.log(err)
    //         })
    //     })
    // },
    delUser({commit}, params) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/user/delUser", params).then(response => {
                res(response.body)
            }).catch(err => {
                onsole.log(err)
            })
        })
    },
    findTagQuotelist({commit}, params) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/base/tag/findTagQuote", params).then(response => {
                res(response.body.list)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    /*-----------------------------------------------------角色------------------------------------------------*/
    //修改角色
    editRole({commit}, params) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/role/modefyRole", params).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    //新增角色
    saveRole({commit}, params) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/role/saveRole", params).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    //删除角色
    delRole({commit}, id) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/role/delRole", {roleId: id}).then(response => {
                res(response.body)
            }).catch(err => {
                onsole.log(err)
            })
        })
    },
    //用户配置角色
    configRoles({commit}, params) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/role/roleUserSave", params).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    //租户配置角色
    configTanantUser({commit}, params) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/role/roleTanantUserSave", params).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    //角色配置资源
    configResources({commit}, params) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/role/roleResourceSave", params).then(response => {
                res(response.body)
                //根据引用ID查询引用数据
            }).catch(err => {
                console.log(err)
            })
        })
    },

    /*-------------------------------------------------------------------------权限管理-------------------------------------------------------------------------*/
    findeAuthorityByResourcesId({commit}, resourcesId) {
        return new Promise((res) => {
            Vue.http.get(vm.requetHost + "/sys/authotity/findeAuthorityByResourcesId", {params: {resourcesId: resourcesId}}).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    saveAuthority({commit}, param) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/authotity/save", param).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    deleteAuthorityByResourcesId({commit}, param) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/authotity/deleteAuthorityByResourcesId", param).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    roleAuthoritySave({commit}, param) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/authotity/roleAuthoritySave", param).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    roleAuthoritySave({commit}, param) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/authotity/roleAuthoritySave", param).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    //------------------------------------------获取菜单按钮---------------------------------------------------------//

    getButton({commit}, pid) {
        return new Promise((res) => {
            var userName = vm.getcookie("username");

            Vue.http.get(vm.requetHost + "/sys/resource/findUserBtnAll", {
                params: {
                    pid: pid,
                    userName: userName
                }
            }).then(response => {

                res(response.body)

            }).catch(err => {
                console.log(err)
            })
        })
    },
    delTenant({commit}, id) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/tenant/delTenant", {id: id}).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    delOrg({commit}, id) {
        return new Promise((res) => {
            Vue.http.post(vm.requetHost + "/sys/org/delOrg", {id: id}).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },

    updateBtnState(_this, pid) {
        getbuttonAll(_this, pid);
    },
//获取租户getTenantList
    getTenantList({commit}) {
        return new Promise((res) => {
            Vue.http.get(vm.requetHost + "/sys/tenant/findTenantList", {params: {}}).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    //获取除ADMIN外所有租户getTenantList
    getTenantListWithFlag({commit}) {
        return new Promise((res) => {
            Vue.http.get(vm.requetHost + "/sys/tenant/findTenantListWithFlag", {params: {}}).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    /*-----------------------------------------------------------提货码------------------------------------------------------------------------*/
    //对提货码启用停用
    excodeClient({commit},params){
        return new Promise((res) => {
            Vue.http.post(vm.requetCodeHost + "/exManager/startOrStopExcode",params).then(response => {
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    //新增/修改/用户
    addExcodeStock({commit},params){
        return new Promise((res) => {
            Vue.http.post(vm.requetCodeHost+"/exManager/addExcodeStock",params).then(response =>{
                res(response.body)
            }).catch(err => {
                console.log(err)
                this.$message({showClose: true,message: '网络异常',type: 'error'});
            })
        })
    },
    /*活动删除*/
    delActAdvertis({commit},actId){
        return new Promise((res) => {
            Vue.http.post(vm.requetCodeHost+"/activity/delActAdvertis",{actId:actId,Token: localStorage.getItem('Token')}).then(response =>{
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    delActExcode({commit},actId){
        return new Promise((res) =>{
            Vue.http.post(vm.requetCodeHost+"/activity/delActExcode",{actId:actId,Token: localStorage.getItem('Token')}).then(response =>{
                res(response.body)
            }).catch(err => {
                console.log(err)
            })
        })
    },
}

const getbuttonAll = (_this, pid) => {
    let data = {
        pid: pid,
        userName: vm.getcookie("username")
    }

    Vue.http.get(vm.requetHost + "/sys/resource/findUserBtnAll", {params: data}).then(response => {

        var data = response.body.btnlist;
        if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
                var btnId = "BTN_" + data[i].resourceId;

                _this.commit(btnId, true);
            }
            //  console.log(_this.state);
        }
    }).catch(err => {
        console.log(err)
    })


}






// WEBPACK FOOTER //
// ./src/store/actions.js